module.exports = __webpack_public_path__ + "static/img/地理師資介紹.ab490e52.png";